import { useCallback, useEffect } from "react";
import { useState } from "react";
import { request } from "../../httpClient";

export const useTravelList = (user_id) => {
  const [travelList, setTravelList] = useState([]);
  const [travelLoading, setTravelLoading] = useState<boolean>(false);
  const getTravelList = useCallback(
    async (silent?: boolean) => {
      if (!silent) {
        setTravelLoading(true);
      }
      const result = await request({
        path: user_id ? `trip/list?user_id=${user_id}` : "trip/list",
      });
      setTravelList(result.data?.reverse());
      setTravelLoading(false);
      return result;
    },
    [user_id]
  );

  useEffect(() => {
    getTravelList();
  }, [getTravelList]);

  return { travelList, getTravelList, travelLoading };
};
